import { IPortal, ITranslationKeys } from '@interfaces';
import { portal } from './locale';
import { initialUpper } from './string';
import { __ } from './translation-service';

export const getMonthTranslationKey = (month: number): ITranslationKeys => {
    if (Number.isInteger(month) && month > 0 && month <= 12) {
        return ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'][
            month - 1
        ] as ITranslationKeys;
    }

    throw new Error(`Month is not valid (${month}) it should be 1 to 12`);
};

export const getTranslatedMonth = (month: number) => __(getMonthTranslationKey(month));

export const formatDateToNamedMonthAndYear = (date: string): string => {
    if (date && typeof date === 'string' && date.length === 10) {
        const [year, month, day] = date.split('-');

        if (year && month && day && year.length === 4 && month.length === 2 && day.length === 2) {
            const formated = `${getTranslatedMonth(parseInt(month, 10))} ${year}`;
            return formated.charAt(0).toUpperCase() + formated.slice(1);
        }
    }
    return '';
};

export const toGermanFormat = (date: Date): string =>
    Number.isNaN(date.getTime())
        ? ''
        : date
              .getDate()
              .toString()
              .padStart(2, '0') +
          '.' +
          (date.getMonth() + 1).toString().padStart(2, '0') +
          '.' +
          date.getFullYear();

export const toCountryFormat = (date: Date | null, market: IPortal) => {
    if (date instanceof Date && !Number.isNaN(date.getTime())) {
        if (market === 'de') {
            return toGermanFormat(date);
        }
        // @TODO: Handle other markets
        return toGermanFormat(date);
    }
    return '';
};

export const toDate = (date: string): Date | null => {
    if (date && typeof date === 'string' && date.length === 10) {
        const splitedDate = date.split('-');

        if (
            splitedDate.length === 3 &&
            splitedDate[0].length === 4 &&
            splitedDate[1].length === 2 &&
            splitedDate[2].length === 2
        ) {
            const date = new Date(
                parseInt(splitedDate[0], 10),
                parseInt(splitedDate[1], 10) - 1,
                parseInt(splitedDate[2], 10),
            );

            if (!Number.isNaN(date.getTime())) {
                return date;
            }
        }
    }
    return null;
};

export const formatDepartureReturn = (
    departureDate: string,
    returnDate: string,
    isSingleSale: boolean = false,
): string => {
    //@TODO Format date for different countries
    const departureFormated = isSingleSale
        ? toCountryFormat(toDate(departureDate), portal)
        : formatDateToNamedMonthAndYear(departureDate);
    const returnFormated = isSingleSale
        ? toCountryFormat(toDate(returnDate), portal)
        : formatDateToNamedMonthAndYear(returnDate);

    if (departureFormated && returnFormated && departureFormated === returnFormated) {
        return departureFormated;
    }

    if (departureFormated && returnFormated) {
        return `${departureFormated} - ${returnFormated}`;
    }

    if (departureFormated) {
        return departureFormated;
    }

    if (returnFormated) {
        return returnFormated;
    }

    return '';
};

export const formatDateDDMMMMYYYY = (date: string) => {
    const dateObj = new Date(date);

    return `${dateObj.getDate()}. ${initialUpper(
        getTranslatedMonth(dateObj.getMonth() + 1),
    )} ${dateObj.getFullYear()}`;
};
